import { cn } from "@/lib/utils"
import { NodeTrashIcon } from "./node-icons"

function splitLabel(label: string) {
	const trimmed = label.trim()
	if (!trimmed) return { strong: "", soft: "" }
	const parts = trimmed.split(/\s+/)
	if (parts.length === 1) return { strong: trimmed, soft: "" }
	const soft = parts.pop() ?? ""
	return { strong: parts.join(" "), soft }
}

export function NodeHeader({
	label,
	onDelete,
	leading,
	className,
	variant = "compute",
	selected = false,
}: {
	label: string
	onDelete?: (e: React.MouseEvent) => void
	leading?: React.ReactNode
	className?: string
	variant?: "compute" | "rail"
	selected?: boolean
}) {
	const usesAccentRow = selected
	const { strong, soft } = splitLabel(label)
	const actionToneClassName = "text-black"

	function NodeActionButton({
		title,
		onClick,
		children,
		active = false,
		revealOnNodeHover = false,
		persistVisible = false,
	}: {
		title: string
		onClick: (e: React.MouseEvent) => void
		children: React.ReactNode
		active?: boolean
		revealOnNodeHover?: boolean
		persistVisible?: boolean
	}) {
		return (
			<button
				type="button"
				onClick={onClick}
				className={cn(
					"group/action flex h-[16px] w-[16px] items-center justify-center transition-opacity duration-150",
					actionToneClassName,
					revealOnNodeHover &&
						"opacity-0 group-hover/node:opacity-100 focus-visible:opacity-100",
					persistVisible && "opacity-100",
				)}
				title={title}
			>
				<span
					className={cn(
						"transition-opacity duration-150",
						active ? "opacity-72" : "opacity-25 group-hover/action:opacity-65",
					)}
				>
					{children}
				</span>
			</button>
		)
	}

	return (
		<div
			className={cn(
				"relative flex w-full items-center justify-between gap-[5px]",
				className,
			)}
		>
			<div className="flex min-w-0 flex-1 items-center gap-[5px]">
				{leading}
				<div
					className={cn(
						"truncate text-[14px] leading-[normal]",
						usesAccentRow ? "text-white" : "text-[var(--node-text)]",
					)}
				>
					<span className="font-bold">{strong}</span>
					{soft ? <span className="font-medium">{` ${soft}`}</span> : null}
				</div>
			</div>
			<div className="flex items-center gap-[10px]">
				{onDelete ? (
					<NodeActionButton
						title="Delete node"
						onClick={onDelete}
						revealOnNodeHover
					>
						<NodeTrashIcon />
					</NodeActionButton>
				) : null}
			</div>
		</div>
	)
}
